module.exports = __webpack_public_path__ + "3f16e137/img/mini-logo.18817ee5.svg";